<template>
  <div class="w-full flex justify-center relative">
    <div v-if="isLoading" class="absolute w-full top-0 left-0 h-full"></div>
    <div class="main-container py-4 mt-8">
      <zt-button
        color="dark-400"
        icon="angle-left"
        text
        class="go-back"
        @click="goBack"
        data-vs-button="go-back"
      >
        {{ $t('message.selfService.goBack') }}
      </zt-button>
      <div class="heading pb-6 flex items-center">
        <h2 class="font-normal text-zt-primary-200">
          {{ $t('message.selfService.title') }}
        </h2>
      </div>
      <zt-accordion>
        <zt-accordion-item
          :title="$t('message.selfService.sections.contact')"
          class="mb-4"
          prepend-icon="phone-outlined"
          :visible="isActionAllowed('201')"
        >
          <div class="px-12 py-8">
            <self-service-contact-information
              v-if="!isLoading"
              :info="selfServiceInfo.contact"
              :updateFn="updateSelfServiceInfo"
            />
          </div>
        </zt-accordion-item>
        <zt-accordion-item
          :title="$t('message.selfService.sections.bank')"
          class="mb-4"
          prepend-icon="bank-outlined"
          :visible="isActionAllowed('202')"
        >
          <div class="px-12 py-8">
            <self-service-bank-information
              v-if="!isLoading"
              :info="selfServiceInfo.bank"
              :updateFn="updateSelfServiceInfo"
            />
          </div>
        </zt-accordion-item>
        <zt-accordion-item
          :title="$t('message.selfService.sections.identifies')"
          class="mb-4"
          prepend-icon="user-outlined"
          :visible="isActionAllowed('203')"
        >
          <div class="px-12 py-8">
            <self-service-my-identify-info
              v-if="!isLoading"
              :info="selfServiceInfo.identifyMyself"
              :updateFn="updateSelfServiceInfo"
            />
          </div>
        </zt-accordion-item>
        <zt-accordion-item
          :title="$t('message.selfService.sections.address')"
          class="mb-4"
          prepend-icon="world-outlined"
          :visible="isActionAllowed('204')"
        >
          <div class="px-12 py-8">
            <self-service-address-change
              v-if="!isLoading"
              :info="selfServiceInfo.address"
              :updateFn="updateSelfServiceInfo"
            />
          </div>
        </zt-accordion-item>
      </zt-accordion>
    </div>
  </div>
</template>

<script>
import { mapValues } from 'lodash'
import { mapGetters, mapState } from 'vuex'
import Users from '@/apiClient/Users'
import ztAccordion from '@/modules/SelfService/generic/Accordion'
import ztAccordionItem from '@/modules/SelfService/generic/AccordionItem'
import SelfServiceAddressChange from '@/modules/SelfService/components/sichernpeople/SelfServiceVpAddressChange'
import SelfServiceContactInformation from '@/modules/SelfService/components/SelfServiceContactInformation'
import SelfServiceBankInformation from '@/modules/SelfService/components/SelfServiceBankInformation'
import SelfServiceMyIdentifyInfo from '@/modules/SelfService/components/SelfServiceMyIdentifyInfo'

const bool = [true, 't', 1]
export default {
  name: 'SelfServicePanel',
  components: {
    SelfServiceContactInformation,
    SelfServiceAddressChange,
    ztAccordion,
    ztAccordionItem,
    SelfServiceBankInformation,
    SelfServiceMyIdentifyInfo
  },
  data() {
    return {
      actionsFilter: [],
      isLoading: true,
      selfServiceInfo: {
        dataContact: {},
        bank: {},
        identifyMyself: {},
        address: {}
      },
      avatar: ''
    }
  },
  computed: {
    ...mapGetters(['getActions', 'getUser']),
    ...mapState(['actions'])
  },
  async created() {
    this.actionsFilter = this.getActions.filter(
      action => parseInt(action.id) <= 204 && parseInt(action.id) >= 201
    )
    this.userApi = new Users()
    try {
      const {
        data: { data }
      } = await this.userApi.getServiceAllInfo()
      if (data && data.identifyMyself && bool.includes(data.identifyMyself.url_picture)) {
        await this.getUserPhoto()
        data.identifyMyself['file'] = this.avatar
      }
      if (data) {
        this.selfServiceInfo = mapValues(data, (requested) => {
          return { ...requested, pending: 'id' in requested }
        })
      }
    } catch (e) {
      console.error('Error al cargar datos de selfservice:', e)
    } finally {
      this.isLoading = false
    }
  },
  methods: {
    hasHistory() {
      return window.history.length > 2
    },
    goBack() {
      // const isNewDashboardAvailable = this.actions.some(objeto => objeto.id === '307');
      // isNewDashboardAvailable ? window.location.href = `${window.location.origin}/v3` : this.$router.push('/');
      this.$router.push('/')
    },
    isActionAllowed(id) {
      return this.actionsFilter.some(action => String(action.id) === String(id))
    },
    async updateSelfServiceInfo() {
      const {
        data: { data }
      } = await this.userApi.getServiceAllInfo()
      if (bool.includes(data.identifyMyself.url_picture)) {
        await this.getUserPhoto()
        data.identifyMyself['file'] = this.avatar
      }
      this.selfServiceInfo = mapValues(data, (requested) => {
        return { ...requested, pending: 'id' in requested }
      })
    },
    async getUserPhoto() {
      this.avatar = ''
      try {
        const { headers, data: file } = await this.userApi.getUserPhoto()
        if (file) {
          const imageType = headers['content-type']
          const ext = imageType.split('/').pop()
          this.avatar = new File([file], 'photo.' + ext, { type: imageType })
        }
      } catch (e) {}
    }
  }
}
</script>

<style scoped lang="scss">
.main-container {
  width: 610px;
  h2 {
    font-size: 24px;
  }
  .heading {
    height: 50px;
    h2 {
      color: #707070;
    }
  }
  .main {
    height: auto;
  }
  ::v-deep {
    .zt-button.go-back {
      background: none !important;
      color: #707070 !important;
      padding: 4px !important;
      margin: 0;
      font-size: 1.2rem !important;
      span:first-child {
        width: 10px;
      }
      span.zt-button-text {
        margin-top: 2px;
      }
    }
  }
}
@media all and (max-width: 1024px) {
  .main-container {
    width: calc(100% - 4rem);
  }
}
</style>
